import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Icon,
  InputNumber,
  Modal,
  Row,
  Table,
  Tooltip,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import XLSX from "xlsx";

import {
  ADD_PATIENT_DETAILS,
  EDIT_EPRESCRIPTION,
  EDIT_NONRXMEDICINES,
} from "../../ActionTypes/ActionTypes";
import AddRefillModal from "./AddRefillModal";
import PrintConfirmationModal from "./PrintConfirmationModal";
import PrintOrderSheet from "./PrintOrderSheet";
import PrintOrderSheetForBox from "./PrintOrderSheetForBox";
import PrintRequisitionSheet from "./PrintRequisitionSheet";
import ShowEprescriptionModal from "./ShowEprescriptionsModal";

import AilmentSupport from "./AilmentSupport";
import CarefillPrescriptionModel from "./CarefillPrescriptionLinking/CarefillPrescriptionModal";
import "./Order.css";
import PrintInventoryContent from "./PrintInventoryContent";
import RefillAmountModal from "./RefillAmountModal";

const FormItem = Form.Item;

const { Column } = Table;
const { confirm } = Modal;

class UnwrappedOrder extends Component {
  state = {
    info: "",
    loading: false,
    // makeRefillLoad: false,
    visiblePrintConfirm: false,
    carefillPrescriptionModal: false,
    refillIdConfirm: "",
    refills: [],
    refill: [],
    amountModal: false,
    refill_id: "",
    refillStartDate: "",
    refillDuration: "",
    address: "",
    doctor: "",
    discount: "",
    packagingDate: "",
    medQtyData: [],
    inventoryMeds: [],
    e_prescription: [],
    view_med: false,
    e_modal: false,
    edit_nonRxmed: false,
    confirmPrintLoading: false,
    visibleRefillModal: false,
    generateData: [],
  };

  componentDidMount = () => {
    const { match, setOrderValuesInStore } = this.props;
    const { id } = match.params;

    // Loading state
    this.setState({ loading: true });

    axios({
      method: "get",
      url: `/orders/${id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      setOrderValuesInStore({
        order_id: id,
        user_id: response.data.user.id,
        doctor_id: "",
        ailments: response.data.ailments,
        p_prescriptions_url:
          response.data.e_prescription == null
            ? []
            : response.data.p_prescriptions,
        start_date: response.data.start_date,
        end_date: response.data.end_date,
      });
      this.setState({
        info: response.data,
      });
    });

    axios({
      method: "get",
      url: `/carefills.json?order_id=${id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      // console.log(response.data);
      this.setState({
        refills: response.data,
        loading: false,
      });
    });
  };

  showRefillModal = () => {
    this.setState({ visibleRefillModal: true });
  };

  handleRefillModalCancel = () => {
    this.setState({ visibleRefillModal: false });
  };

  showAmountModal = (record) => {
    // console.log(record);
    this.setState({
      amountModal: true,
      refill_id: record.id,
    });
  };

  saveFormRefAmount = (formRef) => {
    this.formRefAmount = formRef;
  };

  hideAmountModal = () => {
    this.setState({
      amountModal: false,
      refill_id: "",
    });
  };

  onSubmitAmount = () => {
    const { refill_id } = this.state;
    const { form } = this.formRefAmount.props;
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      // console.log(refill_id, values);
      axios({
        method: "put",
        url: `/carefills/${refill_id}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: {
          carefill: values,
        },
      }).then(() => {
        this.hideAmountModal();
        window.location.reload();
      });
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  handleRefillModalCreate = () => {
    const { order_id } = this.props;

    const { form } = this.formRef.props;
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }

      values.start_date = moment(values.start_date).format("YYYY-MM-DD");

      this.setState({ loading: true });
      axios({
        method: "get",
        url: `/orders/${order_id}/generate_refills.json?start_date=${values.start_date}&refill_cycle=${values.refill_length}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: { user: values },
      }).then(() => {
        // console.log(response.data);
        this.setState({ loading: false });
        window.location.reload();
      });

      form.resetFields();
      this.setState({ visibleRefillModal: false });
    });
  };

  handleViewEPrescription = () => {
    const { match } = this.props;
    this.setState({ view_med: true });
    axios({
      method: "get",
      url: `/prescription_medicines.json?order_id=${match.params.id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      // console.log('123',response.data);
      this.setState({
        e_prescription: response.data,
        view_med: false,
        e_modal: true,
      });
    });
  };

  handleEModalCancel = () => {
    this.setState({
      e_modal: false,
      refill: [],
    });
  };

  handleEditEPrescription = async () => {
    const { info } = this.state;
    const { match, setEPrescriptionMedicine, history } = this.props;

    this.setState({ edit_med: true });
    await axios({
      method: "get",
      url: `/prescription_medicines.json?order_id=${match.params.id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      // console.log(response.data);
      this.setState({
        e_prescription: response.data,
        edit_med: false,
      });
      setEPrescriptionMedicine(
        response.data,
        info.e_prescription === null ? "" : info.e_prescription.id
      );
      history.push("/addMedOrder");
    });
  };

  handleEditNonPrescriptionMedicine = async () => {
    const { info } = this.state;
    const { match, setNonRxMedicines, history } = this.props;

    this.setState({ edit_nonRxmed: true });
    await axios({
      method: "get",
      url: `/non_prescription_medicines.json?order_id=${match.params.id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        edit_nonRxmed: false,
      });
      setNonRxMedicines(
        response.data,
        info.e_prescription === null ? "" : info.e_prescription.id
      );
      history.push("/addNonRxMedicine");
    });
  };

  handleViewRefill = (id) => {
    const { refills } = this.state;
    const refill = refills.filter((ref) => ref.id === id);
    // console.log(refill[0]);
    this.setState({ refill: refill[0].prescription_medicines }, () => {
      this.setState({ e_modal: true });
    });
  };

  getRequisitionSheet = (id, start_date, end_date) => {
    this.setState(
      {
        confirmPrintLoading: true,
        refillStartDate: start_date,
        refillDuration: moment(end_date).diff(moment(start_date), "days") + 1,
      },
      () => {
        axios({
          method: "get",
          url: `/requisition_sheet.json?refill_number=${id}`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        }).then((response) => {
          const medicines = response.data.sheet_data_array;
          let medNames = [];
          medicines.map((med) => medNames.push(med.name));
          medNames = [...new Set(medNames)];

          const processedMeds = [];
          // console.log(processedMeds.length);

          medNames.forEach((med) => {
            const filteredMed = medicines.filter(
              (medicine) => medicine.name === med
            );
            let total = 0;
            filteredMed.forEach((filMed) => {
              total += Number(filMed.total_quantity);
            });
            processedMeds.push({
              id: processedMeds.length,
              name: filteredMed[0].name,
              total_quantity: total,
              expiry: " ",
              partner: " ",
              caredose: " ",
              total: "",
            });
          });

          const length = processedMeds.length; // eslint-disable-line

          for (let i = length; i < 22; i++) {
            processedMeds.push({
              id: processedMeds.length,
              name: " ",
              total_quantity: " ",
              expiry: " ",
              partner: " ",
              caredose: " ",
              total: "",
            });
          }

          const packagingDate = response.data.carefill_start_date;
          const discount =
            response.data.discount_percentage === null
              ? ""
              : response.data.discount_percentage;
          const doctors = response.data.doctors.filter(
            (doc) => doc.primary_doctor === true
          );
          const doctorName = doctors.length === 0 ? "" : doctors[0].name;
          const addr = response.data.addresses[0];
          const address =
            addr == null
              ? ""
              : `${addr.line_1 == null ? "" : addr.line_1}, ${addr.line_2 == null ? "" : addr.line_2
              }, ${addr.city == null ? "" : addr.city}, ${addr.pin_code == null ? "" : addr.pin_code
              }, ${addr.state == null ? "" : addr.state}`;

          this.setState(
            {
              medQtyData: processedMeds,
              address,
              doctor: doctorName,
              discount,
              packagingDate,
              confirmPrintLoading: false,
            },
            () => {
              const printRequisitionContent = document.getElementById(
                "print-requisition-content"
              ).innerHTML;
              document.body.innerHTML = printRequisitionContent;
              window.print();
              window.location.reload();
            }
          );
        });
      }
    );
  };

  showPrintConfirm = (id) => {
    this.setState({
      visiblePrintConfirm: true,
      refillIdConfirm: id,
    });
  };

  handleSendRefillForPrinting = (id) => {
    const { refills } = this.state;
    const { match } = this.props;
    const refill = refills.filter((ref) => ref.id === id);
    const order_id = match.params.id;
    const start_date = moment(refill[0].carefill_start_date).format(
      "YYYY-MM-DD"
    );
    const cycle =
      moment(refill[0].carefill_end_date).diff(
        moment(refill[0].carefill_start_date),
        "days"
      ) + 1;

    axios({
      method: "get",
      url: `/orders/${order_id}/generate_labels.json?start_date=${start_date}&refill_cycle=${cycle}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        if (response.status === 200) {
          message.success("Print Sent");
        }
        this.hidePrintConfirm();
        console.log(response.data);
      })
      .catch(() => {
        message.error("error");
      });
  };

  hidePrintConfirm = () => {
    this.setState({
      visiblePrintConfirm: false,
      refillIdConfirm: "",
    });
  };

  handleDeleteRefill = (id) => {
    axios({
      method: "delete",
      url: `/carefills/${id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      console.log(response.data);
      window.location.reload();
    });
  };

  handlePrintRefillOrderSheet = async (id, start_date, end_date) => {
    this.setState({
      loading: true,
      refillStartDate: start_date,
      refillDuration: moment(end_date).diff(moment(start_date), "days") + 1,
    });
    await axios({
      method: "get",
      url: `/order_sheet.json?refill_number=${id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        generateData: response.data,
        loading: false,
      });
    });
    const printContent = document.getElementById("print-content").innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    window.location.reload();
  };

  // handlePrintRefillOrderSheetBox = async (id, start_date, end_date) => {
  //   this.setState({
  //     loading: true,
  //     refillStartDate: start_date,
  //     refillDuration: moment(end_date).diff(moment(start_date), "days") + 1,
  //   });
  //   await axios({
  //     method: "get",
  //     url: `/order_sheet.json?refill_number=${id}`,
  //     headers: { Authorization: sessionStorage.getItem("jwtToken") },
  //   }).then((response) => {
  //     this.setState({
  //       generateData: response.data,
  //       loading: false,
  //     });
  //   });
  //   const printContent = document.getElementById("print-content-box").innerHTML;
  //   document.body.innerHTML = printContent;
  //   window.print();
  //   window.location.reload();
  // };

  handlePrintRefillOrderSheetBox = async (id, start_date, end_date) => {
    this.setState({
      loading: true,
      refillStartDate: start_date,
      refillDuration: moment(end_date).diff(moment(start_date), "days") + 1,
    });

    await axios({
      method: "get",
      url: `/order_sheet.json?refill_number=${id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      const [timeRow, directionRow, medicineRow] = response.data;

      const row1 = {};
      const row2 = {};
      const row3 = {};

      Object.keys(timeRow).forEach((key) => {
        row1[key] = timeRow[key] || '';
        row2[key] = directionRow[key] || '';
        const safeMedicine = (medicineRow[key] || '').replace(/\n/g, '<br/>');
        // const safeMedicine = (medicineRow[key] || '')
        //   .replace(/\n/g, '<br/>')
        //   .replace(/"/g, '&quot;')

        row3[key] = `
        <div style="display: flex; justify-content: center; align-items: flex-start; min-height: 60px;">
        <div class="rotateText">${safeMedicine}</div>
        </div>
        `;
      });

      this.setState({
        generateData: [row1, row2, row3],
        loading: false,
      });
    });

    setTimeout(() => {
      const printContent = document.getElementById("print-content-box").innerHTML;
      document.body.innerHTML = printContent;
      window.print();
      window.location.reload();
    }, 100);
  };

  handlePrintExcelRefillOrderSheet = async (id, start_date, end_date) => {
    const { info } = this.state;

    this.setState({
      confirmPrintLoading: true,
      refillStartDate: start_date,
      refillDuration: moment(end_date).diff(moment(start_date), "days") + 1,
    });
    await axios({
      method: "get",
      url: `/order_sheet.json?refill_number=${id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        generateData: response.data,
        confirmPrintLoading: false,
      });

      const ws_data = this.processDataForExcel(response.data);
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      const wb = XLSX.utils.book_new();

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "dose sheet");

      const name = `${info.user !== null ? info.user.first_name : "demo"}.xlsx`;
      XLSX.writeFile(wb, name);
    });
  };

  processDataForExcel = (data) => {
    const processedData = [];

    const doses = [];
    doses.push(" ");
    const dosesValues = Object.values(data[0]);
    for (let i = 0; i < dosesValues.length; i++) {
      doses.push(`DOSE ${i + 1}`);
    }

    const times = [];
    times.push("TIME");
    const timesValues = Object.values(data[0]);
    timesValues.forEach((val) => {
      times.push(val);
    });

    const fds = [];
    fds.push("FOOD DIRECTIONS");
    const fdValues = Object.values(data[1]);
    fdValues.forEach((val) => {
      fds.push(val.toUpperCase());
    });

    const meds = [];
    meds.push("MEDICINES");
    const medValues = Object.values(data[2]);
    medValues.forEach((val) => {
      meds.push(val);
    });

    const adrs = [];
    adrs.push("ADDITIONAL REMARKS");
    const adrValues = Object.values(data[2]);
    adrValues.forEach(() => {
      adrs.push(" ");
    });

    processedData.push(doses);
    processedData.push(times);
    processedData.push(fds);
    processedData.push(meds);
    processedData.push(adrs);

    return processedData;
  };

  handlePrintInventorySheet = async (id, start_date, end_date) => {
    this.setState({
      confirmPrintLoading: true,
      refillStartDate: start_date,
      refillDuration: moment(end_date).diff(moment(start_date), "days") + 1,
    });
    await axios({
      method: "get",
      url: `/carefills/${id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        inventoryMeds: response.data.medicine_strips,
        confirmPrintLoading: false,
      });
    });
    const printContent = document.getElementById(
      "print-inventory-content"
    ).innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    window.location.reload();
  };

  handlePrefetchRefill = (event) => {
    event.preventDefault();
    const { form, match } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        // console.log(values, "Refill Prefetch");
        const start_date = moment(values.start_date).format("YYYY-M-D");
        const { id } = match.params;
        const cycle = values.cycle; // eslint-disable-line prefer-destructuring
        // console.log(values);
        axios({
          method: "get",
          url: `/orders/${id}/prefetch_refills.json?start_date=${start_date}&refill_cycle=${cycle}`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        }).then((response) => {
          // console.log(response.data);
          form.resetFields();
          this.setState({ refill: response.data }, () => {
            this.setState({ e_modal: true });
          });
        });
      }
    });
  };

  showCarefillPrescriptionModal = (record) => {
    // console.log(record);
    this.setState({
      carefillPrescriptionModal: true,
      refillIdConfirm: record.id,
    });
  };

  handleCarefillPrescriptionHide = () => {
    this.setState({
      carefillPrescriptionModal: false,
      refillIdConfirm: "",
    });
  };

  showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure?",
      content:
        "This refill will be deleted from the database & can not be recovered.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        this.handleDeleteRefill(id);
      },
      onCancel: () => {
        console.log("Cancel");
      },
    });
  };

  handleSetCarefill = async (id) => {
    await axios({
      method: "post",
      url: `/api/dosedroid_carefill_set/set_carefill?carefill_number=${id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((res) => {
        if (res.status === 200) {
          alert("Carefill set");
        } else {
          alert("Failed to set carefill");
        }
      })
      .catch((err) => {
        alert("Failed to set carefill");
      });
  };
  render() {
    // console.log(Object.keys(this.state.generateData[0]).length);
    const { form, history, e_prescription_id } = this.props;
    const {
      generateData,
      info,
      loading,
      refills,
      view_med,
      e_modal,
      refill,
      e_prescription,
      address,
      doctor,
      discount,
      packagingDate,
      edit_nonRxmed,
      edit_med,
      refillStartDate,
      refillDuration,
      visibleRefillModal,
      makeRefillLoad,
      medQtyData,
      visiblePrintConfirm,
      refillIdConfirm,
      amountModal,
      carefillPrescriptionModal,
      inventoryMeds,
    } = this.state;

    const { getFieldDecorator } = form;
    return (
      <div>
        <Card
          title="Order Details"
          extra={
            <Button type="primary" onClick={history.goBack}>
              <Icon type="left" />
              Go Back
            </Button>
          }
          loading={loading}
          bordered
          style={{
            width: "85%",
            minHeight: "500px",
            margin: "auto",
            textAlign: "center",
            boxShadow: "3px 3px 5px 6px #ccc",
          }}
        >
          <div>
            <p>Order ID - {info.id}</p>
            <p>
              Patient Name -{" "}
              {info.user === undefined
                ? null
                : `${info.user.first_name} ${info.user.last_name}`}
            </p>
            <p>
              Start Date -{" "}
              {refills.length === 0 ? "Not Started Yet" : info.start_date}
            </p>
            <p>
              End Date -{" "}
              {refills.length === 0 ? "Not Started Yet" : info.end_date}
            </p>
            <p>
              Location Name -{" "}
              {info.partner === undefined
                ? null
                : `${info.partner_location.name}`}
            </p>
          </div>

          <br />

          <hr />

          <AilmentSupport />

          <hr />

          <br />

          <div>
            <Row type="flex" justify="space-around">
              <Col>
                <Button
                  type="primary"
                  loading={view_med}
                  onClick={this.handleViewEPrescription}
                >
                  View e-prescription
                </Button>
                <ShowEprescriptionModal
                  visible={e_modal}
                  onCancel={this.handleEModalCancel}
                  data={refill.length !== 0 ? refill : e_prescription}
                />
              </Col>

              {e_prescription_id == null || e_prescription_id === "" ? null : (
                <Col>
                  <Button
                    type="primary"
                    loading={edit_nonRxmed}
                    onClick={this.handleEditNonPrescriptionMedicine}
                  >
                    {info.e_prescription === null
                      ? "Add non Rx medicine"
                      : "Edit non Rx medicine"}
                  </Button>
                </Col>
              )}

              <Col>
                <Button
                  type="primary"
                  loading={edit_med}
                  onClick={this.handleEditEPrescription}
                >
                  {info.e_prescription === null
                    ? "Add prescription medicine"
                    : "Edit prescription medicine"}
                </Button>
              </Col>

              {/* <Col>
                                <Button
                                    type="primary"
                                    onClick={this.handlePrefetchRefill}
                                >
                                    Refill Prefetch
                                </Button>
                            </Col> */}
            </Row>
          </div>

          {/* Area thet will be printed */}

          <PrintOrderSheet
            info={info}
            generateData={generateData}
            refillStartDate={refillStartDate}
            refillDuration={refillDuration}
            refillLength={refills.length}
          />

          <div id="print-content-box" style={{ display: "none" }}>
            <PrintOrderSheetForBox
              info={info}
              generateData={generateData}
              refillStartDate={refillStartDate}
              refillDuration={refillDuration}
              refillLength={refills.length}
            />
          </div>

          <PrintRequisitionSheet
            info={info}
            address={address}
            doctor={doctor}
            discount={discount}
            startDate={packagingDate}
            generateData={medQtyData}
            refillStartDate={refillStartDate}
            refillDuration={refillDuration}
          />

          <PrintInventoryContent
            info={info}
            generateData={inventoryMeds}
            refillStartDate={refillStartDate}
            refillDuration={refillDuration}
          />

          {/* Area thet will be printed end section */}

          <br />
          <br />

          <h4 style={{ textAlign: "center" }}> Refills </h4>

          <br />

          <Table
            pagination={false}
            dataSource={refills}
            loading={loading}
            rowKey="id"
          >
            <Column title="Refill #" dataIndex="id" />

            <Column title="Start Date" dataIndex="carefill_start_date" />

            <Column
              title="Duration"
              render={(record) =>
                moment(record.carefill_end_date).diff(
                  moment(record.carefill_start_date),
                  "days"
                ) + 1
              }
            />

            <Column title="End Date" dataIndex="carefill_end_date" />

            <Column
              title="Bill"
              render={(bill_amount) => <span>&#8377; {bill_amount}</span>}
              dataIndex="bill_amount"
            />

            <Column
              title="Status"
              render={(record) => {
                if (record.status === 1) {
                  return "Inventorized";
                }
                if (record.status === 2) {
                  return "To Partner";
                }
                if (record.status === 3) {
                  return "To Patient";
                }
                if (record.status === 4) {
                  return "Courier";
                }
                return "";
              }}
            />

            <Column
              title="Action"
              render={(record) => (
                <span>
                  <Tooltip placement="top" title="View Refill">
                    <span
                      onClick={() => this.handleViewRefill(record.id)}
                      role="button"
                    >
                      <a>
                        <Icon type="file-text" />
                      </a>
                    </span>
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Requisition Sheet">
                    <span
                      onClick={() =>
                        this.getRequisitionSheet(
                          record.id,
                          record.carefill_start_date,
                          record.carefill_end_date
                        )
                      }
                      role="button"
                    >
                      <a>
                        <Icon type="file-text" />
                      </a>
                    </span>
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Print Order Sheet">
                    <span
                      onClick={() =>
                        this.handlePrintRefillOrderSheet(
                          record.id,
                          record.carefill_start_date,
                          record.carefill_end_date
                        )
                      }
                      role="button"
                    >
                      <a>
                        <Icon type="info-circle" />
                      </a>
                    </span>
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Box Sheet">
                    <span
                      onClick={() =>
                        this.handlePrintRefillOrderSheetBox(
                          record.id,
                          record.carefill_start_date,
                          record.carefill_end_date
                        )
                      }
                      role="button"
                      style={{ fontSize: '16px', }}
                    >
                      <a>
                        <Icon type="inbox" />
                      </a>
                    </span>
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Print Inventory Sheet">
                    <span
                      onClick={() =>
                        this.handlePrintInventorySheet(
                          record.id,
                          record.carefill_start_date,
                          record.carefill_end_date
                        )
                      }
                      role="button"
                    >
                      <a>
                        <Icon type="snippets" />
                      </a>
                    </span>
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Print Excel Sheet">
                    <span
                      onClick={() =>
                        this.handlePrintExcelRefillOrderSheet(
                          record.id,
                          record.carefill_start_date,
                          record.carefill_end_date
                        )
                      }
                      role="button"
                    >
                      <a>
                        <Icon type="file-excel" />
                      </a>
                    </span>
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Print Refill">
                    <span
                      onClick={() => this.showPrintConfirm(record.id)}
                      role="button"
                    >
                      <a>
                        <Icon type="printer" />
                      </a>
                    </span>
                  </Tooltip>

                  {/* <Tooltip placement="top" title="Print Refill">
                                        <span onClick={() => this.handleSendRefillForPrinting(record.id)} role="button">
                                            <a><Icon type="printer" /></a>
                                        </span>
                                    </Tooltip> */}

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Add Amount">
                    <span
                      onClick={() => this.showAmountModal(record)}
                      role="button"
                    >
                      <a>
                        <Icon type="plus" />
                      </a>
                    </span>
                  </Tooltip>

                  {!(moment().diff(record.carefill_start_date, "days") >= 2) &&
                    record.carefill_status < 3 && (
                      <Tooltip placement="top" title="Delete Refill">
                        <Divider type="vertical" />
                        <span
                          onClick={() => this.showDeleteConfirm(record.id)}
                          role="button"
                        >
                          <a>
                            <Icon type="delete" style={{ color: "red" }} />
                          </a>
                        </span>
                      </Tooltip>
                    )}

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Link Prescription">
                    <span
                      onClick={() => this.showCarefillPrescriptionModal(record)}
                      role="button"
                    >
                      <a>
                        <Icon
                          type="link"
                          style={{
                            color:
                              record.p_prescriptions.length > 0
                                ? "green"
                                : "red",
                          }}
                        />
                      </a>
                    </span>
                  </Tooltip>

                  {/* <Divider type="vertical" />

                  <Tooltip placement="top" title="Set Carefill">
                    <span
                      onClick={() => this.handleSetCarefill(record.id)}
                      role="button"
                    >
                      <a>
                        <Icon
                          type="check-square"
                          style={{
                            color: "green",
                          }}
                        />
                      </a>
                    </span>
                  </Tooltip> */}
                </span>
              )}
            />
          </Table>

          <br />

          {/* <Divider type="horizontal" /> */}

          <br />

          <div style={{ float: "left" }}>
            <Form layout="inline" onSubmit={this.handlePrefetchRefill}>
              <FormItem>
                {getFieldDecorator("start_date", {
                  rules: [
                    { required: true, message: "Start date is required" },
                  ],
                })(<DatePicker placeholder="Start Date" />)}
              </FormItem>

              <FormItem>
                {getFieldDecorator("cycle", {
                  rules: [{ required: true, message: "How many days" }],
                })(
                  <InputNumber
                    placeholder="Length of refill"
                    min={1}
                    style={{ width: "150px" }}
                  />
                )}
              </FormItem>

              <FormItem>
                <Button type="primary" htmlType="submit">
                  Prefetch Refill
                </Button>
              </FormItem>
            </Form>
          </div>

          {amountModal ? (
            <RefillAmountModal
              visible={amountModal}
              wrappedComponentRef={this.saveFormRefAmount}
              onCancel={this.hideAmountModal}
              onCreate={this.onSubmitAmount}
            />
          ) : null}

          {visiblePrintConfirm ? (
            <PrintConfirmationModal
              id={refillIdConfirm}
              visible={visiblePrintConfirm}
              onCancel={this.hidePrintConfirm}
              onCreate={this.handleSendRefillForPrinting}
            />
          ) : null}

          {carefillPrescriptionModal ? (
            <CarefillPrescriptionModel
              id={refillIdConfirm}
              visible={carefillPrescriptionModal}
              onCancel={this.handleCarefillPrescriptionHide}
            />
          ) : null}

          <div style={{ float: "right" }}>
            <Button type="primary" onClick={this.showRefillModal}>
              {" "}
              Add refill{" "}
            </Button>
            <AddRefillModal
              visible={visibleRefillModal}
              wrappedComponentRef={this.saveFormRef}
              onCancel={this.handleRefillModalCancel}
              onCreate={this.handleRefillModalCreate}
              confirmLoading={makeRefillLoad}
            />
          </div>
        </Card>
      </div>
    );
  }
}

const Order = Form.create()(UnwrappedOrder);

const mapStateToProps = (state) => ({
  order_id: state.AppState.order_id,
  e_prescription_id: state.AppState.ep_id,
});

const mapDispatchToProps = (dispatch) => ({
  setNonRxMedicines: (list, ep_id) =>
    dispatch({ type: EDIT_NONRXMEDICINES, payload: { list, ep_id } }),
  setEPrescriptionMedicine: (list, ep_id) =>
    dispatch({ type: EDIT_EPRESCRIPTION, payload: { list, ep_id } }),
  setOrderValuesInStore: (data) =>
    dispatch({ type: ADD_PATIENT_DETAILS, data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Order);



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/Order.js